import { render, staticRenderFns } from "./drawsDetails.vue?vue&type=template&id=2ad60bb2&scoped=true&"
import script from "./drawsDetails.vue?vue&type=script&lang=js&"
export * from "./drawsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad60bb2",
  null
  
)

export default component.exports